import { memo, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import Image from 'next/image'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import Button from 'components/parts/button/button'
import BtnClose from 'public/img/filters/icon_close.svg'

import { Pathname, STATIC_URL } from 'constants/data'
import { cutHashFromURL } from 'utils/getURLData'
import { A_Aibolit_Click, A_Aibolit_Show } from 'utils/analytics/other/banners/aibolit'
import { SessionStorageKeys } from 'constants/storage'

import styles from './banner-aibolit.module.scss'
import usePCWindow from 'hooks/usePCWindow'
import { ScreenSize } from 'constants/media-constanst'

const imgPath = {
  phone: `${STATIC_URL}/banners/ai-phone.png`,
  btnImg: `${STATIC_URL}/banners/ai-btn.png`,
}

const phoneImgData = {
  src: imgPath.phone,
  height: 133,
  width: 148,
  alt: 'телефон',
  unoptimized: true,
}
const btnImgData = {
  src: imgPath.btnImg,
  height: 16,
  width: 16,
  alt: 'иконка звезды ai',
  unoptimized: true,
}

const BannerAibolit = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [animClose, setAnimClose] = useState(false)

  const router = useRouter()
  const path = cutHashFromURL(router.asPath)
  const isMobile = usePCWindow(ScreenSize.mobile)
  const [isAVersion, setIsAVersion] = useState(true)

  const closeBanner = () => {
    setAnimClose(true)
    setTimeout(() => {
      setIsOpen(false)
    }, 1000)
  }

  const clickHandler = () => {
    router.push(`/${Pathname.AI_BOLIT}/landing`)
    A_Aibolit_Click(path)
  }
  useEffect(() => {
    const isShow = sessionStorage.getItem(SessionStorageKeys.BANNER_AIBOLIT)
    A_Aibolit_Show(path)
    if (!isShow) {
      sessionStorage.setItem(SessionStorageKeys.BANNER_AIBOLIT, 'true')
      setIsOpen(true)
    }
  }, [])

  useEffect(() => {
    const localFlag = localStorage.getItem('AB_FLAGS')
    // setIsAVersion(localFlag === 'new')
    const onFlags = (e: CustomEvent) => {
      const flags = e.detail
      if (flags.new_bar) {
        setIsAVersion(flags.new_bar[0] === 'new')
      }
    }
    window.addEventListener('yandexABFlagsLoaded', onFlags as EventListener)
    return () => window.removeEventListener('yandexABFlagsLoaded', onFlags as EventListener)
  }, [])

  if (!isOpen) return null

  return (
    <div
      className={clsx(styles.fixedWrapper, {
        [styles.animClose]: animClose,
        [styles.bannerMod]: isMobile && isAVersion,
      })}
    >
      <WidthLimiter noBottomPadding noLeftPadding noRightPadding noTopPadding>
        <div className={clsx(styles.wrapper)}>
          <Image className={styles.phone} {...phoneImgData} />
          <div className={styles.txt}>
            Получите быстрый ответ на свой вопрос&nbsp;по данной клинической{' '}
            <p className={styles.nowrap}>
              рекомендации с<span>AI Bolit</span>
            </p>
          </div>

          <Button modificator={styles.starBtn} onClick={clickHandler}>
            <>
              Спросить AI Bolit <Image {...btnImgData} />
            </>
          </Button>

          <BtnClose className={styles.whiteBtnClose} onClick={closeBanner} />
        </div>
      </WidthLimiter>
    </div>
  )
}

export default memo(BannerAibolit)
